import ProcessScheduleInstrumentInstanceModel from "@/models/lab/ProcessScheduleInstrumentInstanceModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class ProcessScheduleInstrumentInstanceCollection extends LabServiceCollection {
  model() {
    return ProcessScheduleInstrumentInstanceModel;
  }

}
